<div class="row">
    <div class="col-12">
  
      <div class="card">
        <div class="card-body">
          
            <div class="row" *ngIf="user">
                <div class="col-8">

                    <form class="form" #f="ngForm" [formGroup]="userForm" autocomplete="off">

                        <div class="row">
                            <div class="user-photo-container col-5">
                                <div class="user-photo" (click)="fileField.click()" ngbTooltip="{{ 'USERS.USERS_EDITOR.UP_A_PH' | translate }}">
                                    <input class="hide" type="file" [readOnly]="!editProfile" [multiple]="multiple" #fileField (change)="uploadFileDialogWindow($event.target.files)">
                                    <img *ngIf="avatar" src="{{avatar}}">
                                    <img *ngIf="!avatar" src="/assets/images/no-avatar.png">
                                </div>
                            </div>
                            <div class="col-7">

                                <div class="form-group">
                                    <label for="second_name"><span class="star">*</span> {{ 'USERS.USERS_EDITOR.SECOND_NAME' | translate }}</label>
                                    <input type="text" class="form-control" id="second_name" [readOnly]="!editProfile" formControlName="second_name"><!--class="{{ validatorValue.second_name }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.second_name">
                                            <div class="text-error" *ngIf="validation('second_name', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="second_name"><span class="star">*</span> {{ 'USERS.USERS_EDITOR.FIRST_NAME' | translate }}</label>
                                    <input type="text" class="form-control" id="first_name" [readOnly]="!editProfile" formControlName="first_name"><!--class="{{ validatorValue.first_name }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.first_name">
                                            <div class="text-error" *ngIf="validation('first_name', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="second_name">{{ 'USERS.USERS_EDITOR.LAST_NAME' | translate }}</label>
                                    <input type="text" class="form-control" id="last_name" [readOnly]="!editProfile" formControlName="last_name"><!--class="{{ validatorValue.first_name }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.last_name">
                                            <div class="text-error" *ngIf="validation('last_name', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">

                                <div class="form-group">
                                    <label for="second_name">{{ 'USERS.USERS_EDITOR.DOB' | translate }}</label>
                                    <div class="input-group">
                                        <input class="form-control"  formControlName="date_of_birth" id="date_of_birth" readonly="true" ngbDatepicker #d="ngbDatepicker">
                                        <div class="input-group-append">
                                            <button class="btn btn-outline-secondary calendar" (click)="d.toggle()" [disabled]="!editProfile" type="button">
                                                <i class="bi bi-calendar-event"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.date_of_birth">
                                            <div class="text-error" *ngIf="validation('date_of_birth', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="second_name">Email ({{ 'USERS.USERS_EDITOR.LOGIN' | translate }})</label>
                                    <input type="email" class="form-control" id="login" formControlName="login" [readOnly]="!editProfile"><!--class="{{ validatorValue.login }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.login">
                                            <div class="text-error" *ngIf="validation('login', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr>

                                <div class="form-group">
                                    <label for="second_name">{{ 'USERS.USERS_EDITOR.EFC' | translate }}</label>
                                    <input type="email" class="form-control" id="email" formControlName="email" [readOnly]="!editProfile"><!--class="{{ validatorValue.email }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.email">
                                            <div class="text-error" *ngIf="validation('email', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="second_name">{{ 'USERS.USERS_EDITOR.CF' | translate }}</label>
                                    <input type="text" class="form-control" id="phone" formControlName="phone" [readOnly]="!editProfile"><!--class="{{ validatorValue.phone }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.phone">
                                            <div class="text-error" *ngIf="validation('phone', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row">
                            <div class="btn-save-container col-12">
                                <button type="button" class="btn btn-primary" (click)="onUpdate()" [disabled]="userForm.invalid || !editProfile">{{ 'SAVE' | translate }}</button>
                            </div>
                        </div>

                    </form>

                    <form class="form" #f="ngForm" [formGroup]="passwordForm" autocomplete="off">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="old_password">{{ 'USERS.USERS_EDITOR.OLD_PASS' | translate }}</label>
                                    <input type="password" class="form-control" id="old_password" formControlName="old_password" [readOnly]="!editProfile"><!--class="{{ validatorValue.old_password }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.password">
                                            <div class="text-error" *ngIf="validationPassword('old_password', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="password">{{ 'USERS.USERS_EDITOR.NEW_PASS' | translate }}</label>
                                    <input type="password" class="form-control" id="password" formControlName="password" [readOnly]="!editProfile"><!--class="{{ validatorValue.password }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.password">
                                            <div class="text-error" *ngIf="validationPassword('password', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <label for="confirm_password">{{ 'USERS.USERS_EDITOR.CONFIRM_PASS' | translate }}</label>
                                    <input type="password" class="form-control" id="confirm" formControlName="confirm_password" [readOnly]="!editProfile"><!--class="{{ validatorValue.password }}"-->
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.password">
                                            <div class="text-error" *ngIf="validationPassword('confirm_password', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="row">
                            <div class="btn-save-container col-12">
                                <button type="button" class="btn btn-light btn-pos btn-back" onClick="history.back()">
                                <!-- <button type="button" class="btn btn-light btn-pos col-5 btn-back" routerLink="/users/profile"> -->
                                    <!-- <i class="bi bi-arrow-left-square btn-pos-i"></i> -->
                                    {{ 'BACK' | translate }}
                                </button>
                                <button type="button" class="btn btn-primary btn-pos btn-create" (click)="onUpdatePassword()" [disabled]="passwordForm.invalid || !editProfile">
                                    {{ 'SAVE' | translate }}
                                </button>
                            </div>
                        </div>
                    </form>

                </div>
                <div class="col-4">
                    <!-- Активные подписки -->
                    <button type="button" class="btn btn-primary btn-pos edit-pos btn-create" (click)="editProfile = !editProfile" [disabled]="editProfile">
                        {{ 'EDIT' | translate }}
                    </button>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-12">
                
                </div>
            </div> -->

        </div>
      </div>
  
    </div>
  </div>